/**
 * HTML escaping utility to prevent XSS attacks
 * Escapes HTML meta-characters to their safe equivalents
 */

/**
 * Escapes HTML meta-characters in a string to prevent XSS
 * @param {string} text - The text to escape
 * @returns {string} - The escaped text safe for HTML rendering
 */
export function escapeHtml(text) {
  if (typeof text !== "string") {
    return String(text);
  }

  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#x27;")
    .replace(/\//g, "&#x2F;");
}

/**
 * Escapes HTML attributes to prevent XSS in attribute values
 * @param {string} text - The text to escape for attributes
 * @returns {string} - The escaped text safe for HTML attributes
 */
export function escapeHtmlAttribute(text) {
  if (typeof text !== "string") {
    return String(text);
  }

  return text
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#x27;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

/**
 * Safely renders text as HTML by escaping it first
 * Use this instead of dangerouslySetInnerHTML when you need to render user content
 * @param {string} text - The text to safely render as HTML
 * @returns {object} - Object with __html property safe for dangerouslySetInnerHTML
 */
export function safeHtml(text) {
  return {
    __html: escapeHtml(text),
  };
}
